import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BatchCommandsComponent } from './batch-commands/batch-commands.component';
import { CommandsComponent } from './commands/commands.component';
import { EventsComponent } from './events/events.component';
import { HyundaiPositionComponent } from './hyundai-position/hyundai-position.component';
import { LastPositionComponent } from './last-position/last-position.component';
import { MxtStatusComponent } from './mxt-status/mxt-status.component';
import { SetupAtivacaoComponent } from './setup-ativacao/setup-ativacao.component';

const routes: Routes = [
  {
    path: 'events',
    component: EventsComponent,
  },
  {
    path: 'commands',
    component: CommandsComponent,
  },
  {
    path: 'lastposition',
    component: LastPositionComponent,
  },

  {
    path: 'status',
    component: MxtStatusComponent,
  },
  {
    path: 'setupAtivacao',
    component: SetupAtivacaoComponent,
  },
  {
    path: 'hyundaiPosition',
    component: HyundaiPositionComponent,
  },
  {
    path: 'batchCommands',
    component: BatchCommandsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PacketsRoutingModule {}
